/* eslint-disable react/no-array-index-key */
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { SectionContext, useReport, useSection } from './hooks/use-context';

function SectionHeader() {
  const section = useSection();
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0',
        borderBottom: '1px solid',
        paddingBottom: '8px',
      }}
    >
      <h2 style={{ fontSize: '0.875rem', fontWeight: 600 }}>
        {t('pdf_report.section')}: {section.name}
      </h2>
      {!!section.description && (
        <p style={{ fontSize: '0.875rem' }}>
          {t('pdf_report.description')}: {section.description}
        </p>
      )}
    </div>
  );
}

export function SectionItem({ children }: { children?: React.ReactNode }) {
  return (
    <li
      style={{
        backgroundColor: '#ffffff',
        padding: '5px 0',
      }}
    >
      <SectionHeader />
      {children}
    </li>
  );
}

export function SectionsList({ children }: { children?: React.ReactNode }) {
  const { body } = useReport();

  return (
    <ul style={{ width: '100%', listStyleType: 'none' }}>
      {_.orderBy(body.items, 'position', 'asc').map((section, idx) => (
        <SectionContext value={section} key={`${section.name}-${idx}`}>
          <SectionItem>{children}</SectionItem>
        </SectionContext>
      ))}
    </ul>
  );
}
